'use client';

import { c as _c } from "react/compiler-runtime";
import './shift-role-group.scss';
import { useTranslation } from 'react-i18next';
import { TooltipInfo } from '@sola/ark-core/molecules/tooltip-info/tooltip-info.tsx';
import type { useVolunteerRegistrationSheet } from '../../organisms/volunteer-registration-sheet/volunteer-registration-sheet.logic.ts';
import type { VolunteerSlot } from '../../utils/volunteer-utils.ts';
import { getRoleConfig, groupSlotsByDate } from '../../utils/volunteer-utils.ts';
import { ShiftDateGroup } from '../shift-date-group/shift-date-group.tsx';
type Logic = ReturnType<typeof useVolunteerRegistrationSheet>;
export interface ShiftRoleGroupProps {
  roleLabel: string;
  roleSlots: VolunteerSlot[];
  logic: Logic;
}
export const ShiftRoleGroup: React.FC<ShiftRoleGroupProps> = t0 => {
  const $ = _c(26);
  const {
    roleLabel,
    roleSlots,
    logic
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = ["volunteers"];
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    t
  } = useTranslation(t1);
  let t2;
  let t3;
  let t4;
  let t5;
  let t6;
  if ($[1] !== logic || $[2] !== roleLabel || $[3] !== roleSlots || $[4] !== t) {
    const roleConfig = getRoleConfig(roleLabel);
    const dateGroups = groupSlotsByDate(roleSlots);
    t4 = "PanelShifts__role grid gap-comfy-xs md:gap-0";
    const t7 = t("volunteers:registration.roleAgeRequirement", {
      minAge: roleConfig.rules.minAge ?? 14
    });
    let t8;
    if ($[10] !== t7) {
      t8 = <TooltipInfo triggerClassName="PanelShifts__role-icon shrink-0" iconSize="1.25rem">{t7}</TooltipInfo>;
      $[10] = t7;
      $[11] = t8;
    } else {
      t8 = $[11];
    }
    if ($[12] !== roleLabel || $[13] !== t8) {
      t5 = <h4 className="PanelShifts__role-label flex items-center label-potent label-md gap-snug-xl">{t8}{roleLabel}</h4>;
      $[12] = roleLabel;
      $[13] = t8;
      $[14] = t5;
    } else {
      t5 = $[14];
    }
    if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
      t6 = <div className="PanelShifts__divider relative pr-snug-xl md:pl-comfy-sm" aria-hidden="true"><span className="PanelShifts__divider-circle top-0 absolute" /><span className="PanelShifts__divider-circle bottom-0 absolute" /></div>;
      $[15] = t6;
    } else {
      t6 = $[15];
    }
    t2 = "PanelShifts__slots flex flex-col gap-snug-md w-full";
    let t9;
    if ($[16] !== logic) {
      t9 = t10 => {
        const [dateKey, slots] = t10;
        return <ShiftDateGroup key={dateKey} dateKey={dateKey} slots={slots} logic={logic} />;
      };
      $[16] = logic;
      $[17] = t9;
    } else {
      t9 = $[17];
    }
    t3 = dateGroups.map(t9);
    $[1] = logic;
    $[2] = roleLabel;
    $[3] = roleSlots;
    $[4] = t;
    $[5] = t2;
    $[6] = t3;
    $[7] = t4;
    $[8] = t5;
    $[9] = t6;
  } else {
    t2 = $[5];
    t3 = $[6];
    t4 = $[7];
    t5 = $[8];
    t6 = $[9];
  }
  let t7;
  if ($[18] !== t2 || $[19] !== t3) {
    t7 = <div className={t2}>{t3}</div>;
    $[18] = t2;
    $[19] = t3;
    $[20] = t7;
  } else {
    t7 = $[20];
  }
  let t8;
  if ($[21] !== t4 || $[22] !== t5 || $[23] !== t6 || $[24] !== t7) {
    t8 = <div className={t4}>{t5}{t6}{t7}</div>;
    $[21] = t4;
    $[22] = t5;
    $[23] = t6;
    $[24] = t7;
    $[25] = t8;
  } else {
    t8 = $[25];
  }
  return t8;
};